import { Constants } from "../constants/constants";
import { Injectable } from "@angular/core";
import { HttpClient, HttpParams, HttpHeaders } from "@angular/common/http";

import { Observable, of, throwError } from "rxjs";
import { catchError } from "rxjs/operators";

import Swal from "sweetalert2/dist/sweetalert2.all.js"; //CAMBIA EN PROXIMAS VERSIONES EN ESTA DEBE IMPORTARSE ASI
import { Utils } from "../utils/utils";

@Injectable({
  providedIn: "root"
})
export class TipoNovedadService {
  constructor(private http: HttpClient, private utils: Utils) {}

  public getTiposNovedades(idTipoNovedad): Observable<any> {
    const url =
      Constants.BASE_URL + Constants.URL_TIPO_NOVEDAD + "/" + idTipoNovedad;
    return this.http.get<any>(url /*, {headers:httpHeaders}*/).pipe(
      catchError(err => {
        console.log(JSON.stringify(err));
        if (err.status === 401) {
          this.utils.cerrarSesion();
        } else {
          Swal.fire({
            title: "Error Tipo Novedad",
            text: "Error Cargando Tipos Novedades.",
            type: "error"
          });
        }

        return throwError(err);
      })
    );
  }

  public postTipoNovedad(params): Observable<any> {
    const url = Constants.BASE_URL + Constants.URL_TIPO_NOVEDAD;
    return this.http.post<any>(url, params).pipe(
      catchError(err => {
        if (err.status === 401) {
          this.utils.cerrarSesion();
        } else {
          Swal.fire({
            title: "Error Tipo Novedad",
            text: "Verifique la informacion ingresada.",
            type: "error",
            confirmButtonColor: "#127570"
          });
        }

        return throwError(err);
      })
    );
  }

  public putTipoNovedad(idTipoNovedad, params): Observable<any> {
    const url =
      Constants.BASE_URL + Constants.URL_TIPO_NOVEDAD + "/" + idTipoNovedad;
    return this.http.put<any>(url, params).pipe(
      catchError(err => {
        if (err.status === 401) {
          this.utils.cerrarSesion();
        } else {
          Swal.fire({
            title: "Error Tipo Novedad",
            text: "Error actualizando información del tipo novedad.",
            type: "error"
          });
        }

        return throwError(err);
      })
    );
  }

  public deleteTipoNovedad(idTipoNovedad, usuario): Observable<any> {
    const url =
      Constants.BASE_URL +
      Constants.URL_TIPO_NOVEDAD +
      "/" +
      idTipoNovedad +
      "/" +
      usuario;
    return this.http.delete<any>(url).pipe(
      catchError(err => {
        if (err.status === 401) {
          this.utils.cerrarSesion();
        } else {
          Swal.fire({
            title: "Error Tipo Novedad",
            text: "Error eliminado información tipo novedad.",
            type: "error"
          });
        }

        return throwError(err);
      })
    );
  }
}
